<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title" *ngIf="Languages['Confirm Time-Off Request'] == null">Confirm Time-Off Request</h3>
    <h3 class="modal-title" *ngIf="Languages['Confirm Time-Off Request'] != null">{{Languages["Confirm Time-Off Request"]["TranslateLabel"]}}</h3>
</div>
<div class="modal-body" style="max-height: 500px; overflow: auto;">
    <table class="table">
        <thead>
            <tr>
                <th *ngIf="requestType != 'P' && Languages['Request Type'] == null"><strong>Request Type</strong></th>
                <th *ngIf="requestType != 'P' && Languages['Request Type'] != null"><strong>{{Languages["Request Type"]["TranslateLabel"]}}</strong></th>
                <th *ngIf="requestType == 'P' && Languages['Partial Day'] == null"><strong>Partial Day</strong></th>
                <th *ngIf="requestType == 'P' && Languages['Partial Day'] != null"><strong>{{Languages["Partial Day"]["TranslateLabel"]}}</strong></th>
                <th *ngIf="requestType == 'P' && Languages['Dates'] == null"><strong>Dates</strong></th>
                <th *ngIf="requestType == 'P' && Languages['Dates'] != null"><strong>{{Languages["Dates"]["TranslateLabel"]}}</strong></th>
                <th></th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let request of requests">
                <td>{{request.RequestString}}</td>
                <td>{{request.DateString}}</td>
                <td>{{request.Hours | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</td>
            </tr>
            <tr *ngIf="leaveCodeID!=-1 && !hideInitRemainHourModal">
                <td></td>
                <td *ngIf="leaveCodeID!=-1"><b>Initial Hours:</b></td>

                <td *ngIf="leaveCodeID!=-1">{{projectedInitial | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</td>
            </tr>
            <tr>
                <td></td>
                <td><b>Total Requested:</b></td>
                <td>{{total | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</td>
            </tr>
            <tr *ngIf="leaveCodeID!=-1 && !hideInitRemainHourModal">
                <td></td>
                <td><b>New Balance:</b></td>
                <td>{{newBalance | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="submitClicked()" *ngIf="Languages['Submit'] == null">
        Submit
    </button>
    <button type="button" class="btn btn-success" (click)="submitClicked()" *ngIf="Languages['Submit'] != null">
        {{Languages["Submit"]["TranslateLabel"]}}
    </button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()" *ngIf="Languages['Cancel'] == null">
        Cancel
    </button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()" *ngIf="Languages['Cancel'] != null">
        {{Languages["Cancel"]["TranslateLabel"]}}
    </button>
</div>